<template>
  <div>
    <Drawer :closable="false" width="1500" v-model="platformOrderDetailsModal" class="platformOrderDetails_box" @on-visible-change="visibleChange">
      <!--头部-->
      <template #header>
        <div class="flex align-items-center justify-content-between pt8 pb8">
          <div class="flex align-items-center">
            <Icon type="md-arrow-round-forward" color="#FD5425" :size="25" class="cursor" @click="platformOrderDetailsModal = false"/>
            <div class="platformLogo flex align-items-center ml15 mr20">
              <img :src="platformLogoPath" width="107" height="42" alt="">
              <span class="font-size-16 ml12">{{ orderNumber }}</span>
            </div>
            <div class="flex align-items-center" v-if="platformOrderDetails.payTime">
              <span class="title_bold">{{ $t('key1004338') }}</span>
              <span class="color-333">{{ platformOrderDetails.payTime }}</span>
            </div>
          </div>
          <div class="flex align-items-center" v-if="platformOrderDetails.performanceParty !== 'ALIGJ'">
            <!--TE-25121需求调整移除此功能-->
            <!--<Button v-if="showReplaceOrderBtn" @click="$refs.replaceGoods.open(ymsOrderInfoList,platformOrderDetails)" class="mr15">更换订单商品</Button>-->
            <Button v-if="getPermission('ymsPlatformOrder_invalid') && showCancelOrderBtn
            && !cannotCancelPlatformOrdersList.includes(platformOrderDetails.platformId)"
              @click="cancelOrderBtn('platformOrder')">{{ $t('key1006049') }}</Button>
          </div>
        </div>
      </template>
      <!--主体内容-->
      <div>
        <!--订单取消原因-->
        <Alert type="error" style="width: 98%; margin: 12px auto 0" v-if="(cancelledTalg || platformOrderDetails.partTalg) && cancelStatusTalg">
          <h3>{{ $t('key1006075') + platformOrderDetails.invalidTypeText }}</h3>
          <h3 class="mt8 mb8">{{ $t('key1006276') + platformOrderDetails.invalidTime }}</h3>
          <h3>{{ $t('key1001071') + (platformOrderDetails.invalidReason ? platformOrderDetails.invalidReason : '') }}</h3>
        </Alert>
        <div class="platformOrderContent_box">
          <!--左边-->
          <div class="left_box">
            <!--平台订单信息-->
            <div class="platformOrderInfo_box mb10">
              <h2 class="title_styles mb6">{{ $t('key1004467') }}</h2>
              <div class="wid100P back-fff p10">
                <!--平台订单的进度条-->
                <Steps :current="platformOrderCurrent" class="mt5 mb10">
                  <Step
                    v-for="(item, index) in platformOrderStepList"
                    :key="index"
                    :title="item.title"
                    :icon="item.icon"
                    :content="item.time">
                  </Step>
                </Steps>
                <!--商品信息-->
                <template v-if="platformOrderDetails.ymsPlatformOrderTransactions && platformOrderDetails.ymsPlatformOrderTransactions.length >0">
                  <div class="goodsInfo_box" v-for="(orderTransaction,index) in platformOrderDetails.ymsPlatformOrderTransactions" :key="index">
                    <!--平台原始单商品-->
                    <Col span="10" class="align-items-start" style="display: flex;">
                      <Tooltip placement="right" theme="light" :transfer="true" transfer-class-name="set_bigimg_style">
                        <img class="img_styles" :src="setImgPath(orderTransaction.pictureUrl)"
                          @error="setErrorImg($event)" alt=""/>
                        <template #content>
                          <img :ref="'originalgoodsImg_' + index" @load="handlerOnloadImg('originalgoodsImg_' + index)"
                            :src="setImgPath(orderTransaction.pictureUrl)" @error="setErrorImg($event)" alt=""/>
                        </template>
                      </Tooltip>
                      <div class="ml10">
                        <p class="flex align-items-center mb2">
                          <span class="title_bold">{{ $t('key1000100') }}</span>
                          <span class="color-333 ellipsisStyle" :title="orderTransaction.platformItemTitle">
                          {{ orderTransaction.platformItemTitle }}
                        </span>
                        </p>
                        <p class="flex align-items-center mb2">
                          <span class="title_bold">{{ $t('key1000240') }}</span>
                          <span class="color-333 ellipsisStyle" :title="orderTransaction.variations">
                          {{ orderTransaction.variations }}
                        </span>
                        </p>
                        <p class="flex align-items-center mb2">
                          <span class="title_bold">{{ $t('key1006352') }}</span>
                          <span class="color-333 ellipsisStyle" :title="orderTransaction.platformItemSku">
                          {{ orderTransaction.platformItemSku }}
                        </span>
                        </p>
                        <p class="flex align-items-center mb2">
                          <span class="title_bold">ItemID：</span>
                          <span class="color-333 ellipsisStyle" :title="orderTransaction.platformItemId">
                          {{ orderTransaction.platformItemId }}
                        </span>
                        </p>
                        <p class="flex align-items-center mb2">
                          <span class="title_bold">{{ $t('key1006353') }}</span>
                          <span style="color: #2D8CF0">{{ orderTransaction.buyerShippingMethod }}</span>
                        </p>
                      </div>
                    </Col>
                    <!--价格及数量-->
                    <Col span="4" class="flex flex-direction align-items-center">
                      <p class="title_bold">{{ $t('key1006354') }}</p>
                      <p class="color-333">
                        <span>{{ orderTransaction.priceCurrency }}</span>
                        <span class="ml4">{{ orderTransaction.price }}</span>
                        <span>{{ '×' + orderTransaction.quantity }}</span>
                      </p>
                    </Col>
                    <!--SKU信息-->
                    <Col span="10">
                      <div class="flex align-items-start">
                        <!--匹配SKU成功-->
                        <template v-if="[1,2].includes(orderTransaction.matchType)">
                          <Tooltip placement="right" theme="light" :transfer="true" transfer-class-name="set_bigimg_style">
                            <img class="img_styles" :src="setImgPath(orderTransaction.primaryImage, null, '70x70', null, true)"
                              @error="setErrorImg($event)" alt=""/>
                            <template #content>
                              <img :ref="'matchingSuccessImg_' + index" @load="handlerOnloadImg('matchingSuccessImg_' + index)"
                                :src="setImgPath(orderTransaction.primaryImage, null, '400x400', null, true)"
                                @error="setErrorImg($event)" alt=""/>
                            </template>
                          </Tooltip>
                          <div class="ml10">
                            <p class="flex align-items-center mb2">
                              <span class="title_bold">{{ $t('key1006355') }}</span>
                              <span class="color-333 ellipsisStyle" :title="orderTransaction.decodedSku">{{ orderTransaction.decodedSku }}</span>
                              <!--0待处理 1.待匹配商品 11.待匹配商品发货仓-->
                              <Icon type="md-create" size="18" v-if="[0,1,11].includes(platformOrderDetails.status) && platformOrderDetails.ymsPlatformOrderShippings.length <=0"
                                @click="marryGoods(orderTransaction)"
                                class="cursor distributorThemeColor ml8" style="position: relative; top: -3px;"/>
                            </p>
                            <p class="flex align-items-center mb2">
                              <Icon class="font-size-19 mr5" type="ios-checkmark-circle" color="#008000"></Icon>
                              <span style="color:#008000;">{{ orderTransaction.matchType === 1 ? $t('key1006342') : $t('key1006343') }}</span>
                            </p>
                            <p class="flex align-items-center mb2">
                              <span class="title_bold">{{ $t('key1000100') }}</span>
                              <span class="color-333 ellipsisStyle" :title="orderTransaction._productInfo._spuInfo.name" v-if="orderTransaction._productInfo">
                                {{ orderTransaction._productInfo ? orderTransaction._productInfo._spuInfo.name : '' }}
                              </span>
                            </p>
                            <p class="flex align-items-center mb2">
                              <span class="title_bold">{{ $t('key1000240') }}</span>
                              <span class="color-333 ellipsisStyle" :title="orderTransaction.specifications">
                                {{ orderTransaction.specifications }}
                              </span>
                            </p>
                            <p class="flex align-items-center mb2">
                              <span class="title_bold">{{ configCharacters(false) + 'SKU：' }}</span>
                              <span class="color-333 ellipsisStyle" :title="orderTransaction.ymsSku">{{ orderTransaction.ymsSku }}</span>
                            </p>
                            <p class="flex align-items-center mb2">
                              <span class="title_bold">{{ $t('key1004389') }}</span>
                              <span class="color-333 ellipsisStyle" :title="orderTransaction.shippingWarehouseName">
                                {{ orderTransaction.shippingWarehouseName }}
                              </span>
                              <Icon type="md-create" size="18" class="cursor distributorThemeColor ml8"
                                style="position: relative; top: -3px;"
                                v-if="platformOrderDetails.ymsPlatformOrderShippings.length <=0"
                                @click="$refs['shippingWarehouse'].initShippingWarehouseData(orderTransaction, 'platformDetails',
                                platformOrderDetails.ymsPlatformOrderId)"/>
                            </p>
                          </div>
                        </template>
                        <!--匹配通途商品失败/ 不匹配sku-->
                        <template v-if="orderTransaction.matchType === 0">
                          <!--不匹配SKU-->
                          <template v-if="orderTransaction.isMatchSku === 0">
                            <div>
                              <p class="flex align-items-center mb2">
                                <span class="title_bold">{{ $t('key1006355') }}</span>
                                <span class="color-333 ellipsisStyle" :title="orderTransaction.decodedSku">{{ orderTransaction.decodedSku }}</span>
                              </p>
                              <p class="flex align-items-center mb7">
                                <Icon class="font-size-19 mr5" type="ios-alert" color="#ff0000"></Icon>
                                <span style="color: #ff0000;">{{ $t('key1006356') }}</span>
                              </p>
                              <p class="mb7"> {{ $t('key1006344') + configCharacters(false) + 'SKU' }}</p>
                              <p v-if="!cancelledTalg && platformOrderDetails.status !== 0 && hasAYMSOrderBeenPlaced"
                                @click="marryGoods(orderTransaction)" class="distributorThemeColor cursor">{{ $t('key1006357') }}</p>
                            </div>
                          </template>
                          <!--匹配SKU-->
                          <template v-else>
                            <!--匹配SKU失败-->
                            <div v-if="orderTransaction.matchFailReason === 0">
                              <p class="flex align-items-center mb2">
                                <span class="title_bold">{{ $t('key1006355') }}</span>
                                <span class="color-333 ellipsisStyle" :title="orderTransaction.decodedSku">{{ orderTransaction.decodedSku }}</span>
                              </p>
                              <p class="flex align-items-center mb7">
                                <Icon class="font-size-19 mr5" type="ios-alert" color="#ff0000"></Icon>
                                <span style="color: #ff0000;">{{ $t('key1006358') }}</span>
                              </p>
                              <template v-if="orderTransaction.unmatchedYmsSku">
                                <p v-if="!cancelledTalg && platformOrderDetails.status !== 0" @click="marryGoods(orderTransaction)" class="distributorThemeColor cursor mb7">{{ $t('key1006359') }}</p>
                                <p v-if="!cancelledTalg && orderTransaction.isMatchSku === 1" class="distributorThemeColor cursor" @click="unmatchedYmsSkuBtn(orderTransaction, index)">
                                  {{ $t('key1006344') + configCharacters(false) + 'SKU' }}
                                </p>
                              </template>
                              <template v-else>
                                <p class="mb7">{{ $t('key1006344') + configCharacters(false) + 'SKU' }}</p>
                                <p v-if="!cancelledTalg && platformOrderDetails.status !== 0 && hasAYMSOrderBeenPlaced"
                                  @click="marryGoods(orderTransaction)" class="distributorThemeColor cursor">{{ $t('key1006357') }}</p>
                              </template>
                            </div>
                            <!--SKU已停售-->
                            <div v-else-if="orderTransaction.matchFailReason === 1">
                              <p class="flex align-items-center mb2">
                                <span class="title_bold">{{ $t('key1006355') }}</span>
                                <span class="color-333 ellipsisStyle" :title="orderTransaction.decodedSku">{{ orderTransaction.decodedSku }}</span>
                              </p>
                              <p class="flex align-items-center mb7">
                                <Icon class="font-size-19 mr5" type="ios-alert" color="#ff0000"></Icon>
                                <span style="color: #ff0000;">{{ $t('key1006360') }}</span>
                              </p>
                              <template v-if="orderTransaction.unmatchedYmsSku">
                                <p v-if="!cancelledTalg && platformOrderDetails.status !== 0" @click="marryGoods(orderTransaction)" class="distributorThemeColor cursor mb7">{{ $t('key1006359') }}</p>
                                <p v-if="!cancelledTalg && orderTransaction.isMatchSku === 1" class="distributorThemeColor cursor" @click="unmatchedYmsSkuBtn(orderTransaction, index)">
                                  {{ $t('key1006344') + configCharacters(false) + 'SKU' }}
                                </p>
                              </template>
                              <template v-else>
                                <p class="mb7"> {{ $t('key1006344') + configCharacters(false) + 'SKU' }}</p>
                                <p v-if="!cancelledTalg && platformOrderDetails.status !== 0 && hasAYMSOrderBeenPlaced"
                                  @click="marryGoods(orderTransaction)" class="distributorThemeColor cursor">{{ $t('key1006357') }}</p>
                              </template>
                            </div>
                            <template v-else>
                              <!--待处理-->
                              <div v-if="platformOrderDetails.status === 0">
                                <p class="flex align-items-center mb2">
                                  <span class="title_bold">{{ $t('key1006355') }}</span>
                                  <span class="color-333 ellipsisStyle" :title="orderTransaction.decodedSku">{{ orderTransaction.decodedSku }}</span>
                                </p>
                                <p class="flex align-items-center mb7">
                                  <Icon class="font-size-19 mr5" type="ios-alert" color="#ff0000"></Icon>
                                  <span style="color: #ff0000;">{{ $t('key1006345') + configCharacters() + $t('key1000838') }}</span>
                                </p>
                              </div>
                              <!--商品为空，无法关联-->
                              <div v-else>
                                <p class="flex align-items-center mb2">
                                  <span class="title_bold">{{ $t('key1006355') }}</span>
                                  <span class="color-333 ellipsisStyle" :title="orderTransaction.decodedSku">{{ orderTransaction.decodedSku }}</span>
                                </p>
                                <p class="flex align-items-center mb7">
                                  <Icon class="font-size-19 mr5" type="ios-alert" color="#ff0000"></Icon>
                                  <span style="color: #ff0000;">{{ $t('key1006356') }}</span>
                                </p>
                                <template v-if="orderTransaction.unmatchedYmsSku">
                                  <p v-if="!cancelledTalg && platformOrderDetails.status !== 0" @click="marryGoods(orderTransaction)" class="distributorThemeColor cursor mb7">{{ $t('key1006359') }}</p>
                                  <p v-if="!cancelledTalg && orderTransaction.isMatchSku === 1" class="distributorThemeColor cursor" @click="unmatchedYmsSkuBtn(orderTransaction, index)">
                                    {{ $t('key1006344') + configCharacters(false) + 'SKU' }}
                                  </p>
                                </template>
                                <template v-else>
                                  <p class="mb7"> {{ $t('key1006344') + configCharacters(false) + 'SKU' }}</p>
                                  <p v-if="!cancelledTalg && platformOrderDetails.status !== 0 && hasAYMSOrderBeenPlaced"
                                    @click="marryGoods(orderTransaction)" class="distributorThemeColor cursor">{{ $t('key1006357') }}</p>
                                </template>
                              </div>
                            </template>
                          </template>
                        </template>
                      </div>
                    </Col>
                  </div>
                </template>
              </div>
            </div>
            <!--配置定制信息-->
            <template v-if="platformOrderDetails.status === 12">
              <div class="flex align-items-center justify-content-center mt30 wid100P">
                <h2 class="font-weight-bold font-size-15 color-333">{{ $t('key1006346') + configCharacters() + $t('key1006347') }}</h2>
                <h2 class="font-weight-bold font-size-15 distributorThemeColor cursor"
                  @click="$refs['configureCustomizedContent'].initConfigureCustomizedContentData('platformOrder', platformOrderDetails)">
                  {{ $t('key1006361') }}
                </h2>
              </div>
            </template>
            <!--关联合规信息-->
            <template v-if="platformOrderDetails.status === 13 && orderComplianceLabelVerificationTalg">
              <div class="mt30 wid100P pl20 pr20">
                <span class="font-weight-bold font-size-15 color-333">
                  {{ $t('key1005990') }}
                  {{ $t('key1005991') }}
                </span>
                <span class="font-weight-bold font-size-15 distributorThemeColor cursor"
                  @click="$refs['relatedComplianceInfo'].initRelatedComplianceInfoData(platformOrderDetails)">
                  {{ $t('key1006362') }}
                </span>
              </div>
            </template>
            <template>
              <!--YMS订单信息-->
              <div class="ymsOrderInfo_box mb10" v-if="ymsOrderInfoList.length >0">
                <div class="flex align-items-center justify-content-between mb5">
                  <h2 class="title_styles mb6">{{ configCharacters() + $t('key1004432') }}</h2>
                  <Button type="primary" size="small" class="mr14" v-if="platformOrderDetails.isInvalid !==1"
                    @click="$refs['addYmsOrder'].initAddYmsOrderData('add',null, platformOrderDetails)">{{ $t('key1006171') }}</Button>
                </div>
                <Collapse v-model="collapseModal">
                  <Panel :name="index.toString()" v-for="(item,index) in ymsOrderInfoList" :key="item.ymsPlatformOrderPackageRelatedId" class="mb20">
                    <div class="collapse-header wid100P" @click.stop>
                      <div class="flex align-items-center justify-content-between wid100P">
                        <!--发货信息-->
                        <div class="flex align-items-center" v-if="preSplitOrderStatusTalg">
                          <span :class="(item.ymsPackageInfo && item.ymsPackageInfo.status === 8) ? 'text-line-through' : ''">{{ item.packageCode }}</span>
                          <span class="ml40">{{ $t('key1006007') + item.ymsPackageInfo.orderShippingWarehouseName }}</span>
                        </div>
                        <!--yms订单信息-->
                        <div class="flex align-items-center" v-else>
                          <span :class="(item.ymsPackageInfo && item.ymsPackageInfo.status === 8) ? 'text-line-through' : ''">{{ item.packageCode }}</span>
                          <Tooltip class="ml10 cursor" max-width="300" transfer>
                            <Icon type="md-help-circle" size="18"/>
                            <template #content>
                              <p>{{ $t('key1006363') }}</p>
                              <p>{{ $t('key1006364') }}</p>
                            </template>
                          </Tooltip>
                          <span class="ml5 label">{{ $t('key1006365') }}{{ currencyState }})：</span>
                          <span class="h-price">{{ calcAmount(item) }}</span>
                          <span class="ml10 label">{{ $t('key1006366') }}{{ currencyState }})：</span>
                          <span class="h-price">{{ formatCurrency(item.costOfGoods) }}</span>
                          <span class="ml10 label">{{ $t('key1006367') }}{{ currencyState }})：</span>
                          <span class="h-price">{{ formatCurrency(item.costOfPackage) }}</span>
                          <template v-if="item.costsTypeList.includes(4) || item.costsTypeList.includes(9) ||
                           (item.costsTypeList.length <=0 && item.logisticsOfGoods > 0)">
                            <span class="ml10 label">{{ $t('key1006368') }}{{ currencyState }})：</span>
                            <span class="h-price">{{ formatCurrency(item.logisticsOfGoods) }}</span>
                          </template>
                          <template v-if="item.costsTypeList.includes(6)">
                            <Tooltip class="ml10" max-width="350" transfer>
                              <Icon type="md-help-circle" size="18"/>
                              <template #content>
                                <p>{{ $t('key1006146') }}</p>
                              </template>
                            </Tooltip>
                            <span class="ml5 label">{{ $t('key1006369') }}{{ currencyState }})：</span>
                            <span class="h-price">{{ formatCurrency(item.expressFee) }}</span>
                          </template>
                          <template v-if="item.costsTypeList.includes(7)">
                            <span class="ml10 label">{{ $t('key1006370') }}{{ currencyState }})：</span>
                            <span class="h-price">{{ formatCurrency(item.customsClearanceFee) }}</span>
                          </template>
                          <!--匹配商品成功, 商品发货仓匹配到多个，请拆分平台订单后，再下单。-->
                          <div class="flex align-items-center ml10" v-if="item.failMessage">
                            <Icon style="marginRight:5px; font-size: 19px;" type="md-information-circle" color="#FE0A0A"></Icon>
                            <span style="color:#FE0A0A">{{ item.failMessage }}</span>
                          </div>
                        </div>
                        <div class="flex align-items-center">
                          <div class="flex align-items-center">
                            <Button size="small" class="mr14" v-if="isShowOptionsFun(item, 'splitOrder')"
                              @click.stop="$refs['splitOrder'].initSplitOrderData(item, platformOrderDetails)">{{ $t('key1006371') }}</Button>
                            <Button size="small" class="mr14" v-if="isShowOptionsFun(item, 'adjustOrder')"
                              @click.stop="$refs['addYmsOrder'].initAddYmsOrderData('edit', item, platformOrderDetails)">{{ $t('key1006321') }}</Button>
                            <Button size="small" class="mr14" v-if="isShowOptionsFun(item, 'cancelOrder')"
                              @click.stop="$refs['cancelYmsOrder'].initCancelYmsOrderData(item, platformOrderDetails)">{{ $t('key1004290') }}</Button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <template #content>
                      <div>
                        <!--YMS订单的进度条-->
                        <div class="steps_box" style="width: 98%">
                          <Steps :current="item.currentStatus">
                            <Step
                              v-for="(ele, ids) in item.ymsOrderStepsList"
                              :key="ids"
                              :title="ele.title"
                              :icon="ele.icon">
                              <div slot="content" class="flex flex-direction">
                                <span v-if="ele.text" class="distributorThemeColor">{{ ele.text }}</span>
                                <span>{{ ele.time }}</span>
                              </div>
                            </Step>
                          </Steps>
                        </div>
                        <!--YMS订单商品信息-->
                        <template v-if="item.goodsList && item.goodsList.length >0">
                          <div class="goodsInfo_box mt20 mb20" v-for="(ele,idx) in item.goodsList" :key="idx">
                            <Col span="14" class="align-items-start" style="display: flex;">
                              <Tooltip placement="right" theme="light" :transfer="true" transfer-class-name="set_bigimg_style">
                                <img class="img_yms_styles" :src="setImgPath(ele.pictureUrl, null, '70x70', null, true)"
                                  @error="setErrorImg($event)" alt=""/>
                                <template #content>
                                  <img :ref="'goodsImg_' + idx" @load="handlerOnloadImg('goodsImg_' + idx)"
                                    :src="setImgPath(ele.pictureUrl, null, '400x400', null, true)"
                                    @error="setErrorImg($event)" alt=""/>
                                </template>
                              </Tooltip>
                              <div class="ml10" style="flex: 1;">
                                <p class="flex align-items-center mb6 mt6">
                                  <span class="title_bold">{{ $t('key1000100') }}</span>
                                  <span class="color-333 ellipsisStyle" :title="ele.name">
                                {{ ele.name }}
                              </span>
                                </p>
                                <p class="flex align-items-center mb6">
                                  <span class="title_bold">{{ $t('key1000240') }}</span>
                                  <span class="color-333 ellipsisStyle" :title="ele.variations">{{ ele.variations }}</span>
                                </p>
                                <div class="flex align-items-center mb6">
                                  <!--定制商品的ymsSku-->
                                  <template v-if="ele.isNeedCustomization === 1">
                                    <span class="title_bold">{{ configCharacters(false) + 'SKU：' }}</span>
                                    <span class="color-333 ellipsisStyle" :title="ele.ymsSku">{{ ele.ymsSku }}</span>
                                    <div class="flex align-items-center">
                                      <span>{{ $t('key1006348') + ele.originalYmsSku + '）' }}</span>
                                      <Tooltip transfer placement="top" max-width="500" :content="$t('key1004306')">
                                        <Icon size="20" color="#FD5425" class="cursor" type="md-alert"></Icon>
                                      </Tooltip>
                                    </div>
                                  </template>
                                  <!--非定制商品ymsSku-->
                                  <template v-else>
                                    <span class="title_bold">{{ configCharacters(false) + 'SKU：' }}</span>
                                    <span class="color-333 ellipsisStyle" :title="ele.ymsSku">{{ ele.ymsSku }}</span>
                                  </template>
                                  <p class="flex align-items-center ml10" v-if="ele.abnormalStatusText">
                                    <Icon type="md-alert" color="#FF0000" size="18"/>
                                    <span class="crimsonRedColor font-weight-bold ml5">{{ ele.abnormalStatusText }}</span>
                                  </p>
                                </div>
                                <p class="flex align-items-center mb6">
                                  <span class="title_bold">{{ $t('key1006372') }}</span>
                                  <Select v-model.trim="ele.platformOrderTransactionId" transfer style="width:250px;" class="mr6"
                                    @on-change="platformProductChange">
                                    <Option v-for="talg in ymsPlatformOrderTransactionsList" :value="talg.platformOrderTransactionId" :label="talg.name">
                                      {{ talg.name }}
                                    </Option>
                                  </Select>
                                  <Tooltip transfer placement="top" max-width="500" :content="$t('key1006341')">
                                    <Icon size="20" color="#FD5425" class="cursor" type="md-alert"></Icon>
                                  </Tooltip>
                                </p>
                                <p v-if="[2,3].includes(ele.abnormalStatus)" style="color: #ED1A15">
                                  {{ $t('key1006373') }}
                                </p>
                              </div>
                            </Col>
                            <!--价格及数量-->
                            <Col span="5" class="flex flex-direction align-items-center">
                              <p class="title_bold">{{ $t('key1006354') }}</p>
                              <p class="color-333">
                                <span>{{ preSplitOrderStatusTalg ? ele.goodCurrency : ele.currency }}</span>
                                <span class="ml4">{{ preSplitOrderStatusTalg ? ele.goodSuggestPrice : ele.productGoodsCost }}</span>
                                <span>{{ '×' + ele.quantity }}</span>
                              </p>
                            </Col>
                            <Col span="5" class="flex flex-direction align-items-center">
                              <p class="title_bold">{{ $t('key1000854') }}</p>
                              <p class="color-333">
                                <span>{{ (preSplitOrderStatusTalg ? ele.goodWeight : ele.productGoodsWeight) + 'g' }}</span>
                              </p>
                            </Col>
                          </div>
                        </template>
                        <!--物流商信息-->
                        <template v-if="item.ymsPackageInfo">
                          <Divider style="margin: 8px 0"/>
                          <Row type="flex" :gutter="gutterItem">
                            <Col :span="talg.span ? talg.span : 8" class="basic_item mb10" v-for="talg in logisticsInfoList">
                              <span class="basic_title">{{ talg.title + '：' }}</span>
                              <span class="basic_txt" :title="item.ymsPackageInfo[talg.paramsKey]">
                            {{ item.ymsPackageInfo[talg.paramsKey] }}</span>
                              <Icon
                                v-if="talg.optionTalg && isShowOptionsFun(item, 'logistics')"
                                type="md-create"
                                size="18"
                                @click="operationChange(item, talg)"
                                class="cursor distributorThemeColor ml8"/>
                            </Col>
                            <!--收货地址信息-->
                            <Col span="5" class="flex align-items-center">
                              <span class="basic_title">{{ $t('key1006374') }}</span>
                              <span v-if="isShowOptionsFun(item, 'cancelOrder')" class="basic_txt cursor distributorThemeColor"
                                @click="editShippingAddressInfoBtn(item,'edit')">{{ $t('key1006375') }}</span>
                              <span v-else class="basic_txt cursor distributorThemeColor"
                                @click="editShippingAddressInfoBtn(item,'look')">{{ $t('key1000401') }}</span>
                            </Col>
                          </Row>
                        </template>
                      </div>
                    </template>
                  </Panel>
                </Collapse>
              </div>
              <!--阿里国际订单信息-->
              <div class="ymsOrderInfo_box mb10" v-if="alibabaOrderInfoList.length >0">
                <h2 class="title_styles mb6">{{ $t('key1006376') }}</h2>
                <Collapse v-model="collapseModal">
                  <Panel :name="index.toString()" v-for="(item,index) in alibabaOrderInfoList" :key="item.ymsPlatformOrderPackageRelatedId" class="mb20">
                    <div class="collapse-header" @click.stop>
                      <span class="mr30">{{ $t('key1006349') + (item.ymsPackageInfo.thirdOrderId || '') }}</span>
                      <span :class="(item.ymsPackageInfo && item.ymsPackageInfo.status === 8) ? 'text-line-through' : ''">{{ $t('key1006350') + item.packageCode }}</span>
                      <span class="ml30 label">{{ $t('key1004340') }}</span>
                      <span class="h-price">{{ currencyState + ' ' + item.ymsPackageInfo.totalPrice }}</span>
                      <!--匹配商品成功, 商品发货仓匹配到多个，请拆分平台订单后，再下单。-->
                      <div class="flex align-items-center ml10" v-if="item.failMessage">
                        <Icon style="marginRight:5px; font-size: 19px;" type="md-information-circle" color="#FE0A0A"></Icon>
                        <span style="color:#FE0A0A">{{ item.failMessage }}</span>
                      </div>
                    </div>
                    <template #content>
                      <div>
                        <!--阿里国际订单的进度条-->
                        <div class="steps_box" style="width: 98%">
                          <Steps :current="item.currentStatus">
                            <Step
                              v-for="(ele, ids) in item.ymsOrderStepsList"
                              :key="ids"
                              :title="ele.title"
                              :icon="ele.icon">
                              <div slot="content" class="flex flex-direction">
                                <span v-if="ele.text" class="distributorThemeColor">{{ ele.text }}</span>
                                <span>{{ ele.time }}</span>
                              </div>
                            </Step>
                          </Steps>
                        </div>
                        <!--阿里国际订单商品信息-->
                        <template v-if="item.goodsList && item.goodsList.length >0">
                          <div class="goodsInfo_box mt20 mb20" v-for="(ele,idx) in item.goodsList" :key="idx">
                            <!--商品信息-->
                            <Col span="14" class="align-items-start" style="display: flex;">
                              <Tooltip placement="right" theme="light" :transfer="true" transfer-class-name="set_bigimg_style">
                                <img class="img_yms_styles" :src="setImgPath(ele.pictureUrl, null, '70x70', null, true)"
                                  @error="setErrorImg($event)" alt=""/>
                                <template #content>
                                  <img :ref="'goodsImg_' + idx" @load="handlerOnloadImg('goodsImg_' + idx)"
                                    :src="setImgPath(ele.pictureUrl, null, '400x400', null, true)"
                                    @error="setErrorImg($event)" alt=""/>
                                </template>
                              </Tooltip>
                              <div class="ml10">
                                <p class="flex align-items-center mb6">
                                  <span class="title_bold">{{ $t('key1000100') }}</span>
                                  <span class="color-333 ellipsisStyle" :title="ele.name">
                                {{ ele.name }}
                              </span>
                                </p>
                                <p class="flex align-items-center mb6">
                                  <span class="title_bold">{{ $t('key1000240') }}</span>
                                  <span class="color-333 ellipsisStyle" :title="ele.variations">{{ ele.variations }}</span>
                                </p>
                                <div class="flex align-items-center mb6">
                                  <span class="title_bold">{{ configCharacters(false) + 'SKU：' }}</span>
                                  <span class="color-333 ellipsisStyle" :title="ele.ymsSku">{{ ele.ymsSku }}</span>
                                  <p class="flex align-items-center ml10" v-if="ele.abnormalStatusText">
                                    <Icon type="md-alert" color="#FF0000" size="18"/>
                                    <span class="crimsonRedColor font-weight-bold ml5">{{ ele.abnormalStatusText }}</span>
                                  </p>
                                </div>
                              </div>
                            </Col>
                            <!--价格及数量-->
                            <Col span="5" class="flex flex-direction align-items-center">
                              <p class="title_bold">{{ $t('key1006354') }}</p>
                              <p class="color-333">
                                <span>{{ ele.currency }}</span>
                                <span class="ml4">{{ ele.productGoodsCost }}</span>
                                <span>{{ '×' + ele.quantity }}</span>
                              </p>
                            </Col>
                            <!--重量-->
                            <Col span="5" class="flex flex-direction align-items-center">
                              <p class="title_bold">{{ $t('key1000854') }}</p>
                              <p class="color-333">
                                <span>{{ ele.productGoodsWeight + 'g' }}</span>
                              </p>
                            </Col>
                          </div>
                        </template>
                        <!--物流商信息-->
                        <template v-if="item.ymsPackageInfo">
                          <Divider style="margin: 8px 0"/>
                          <Row type="flex" :gutter="gutterItem">
                            <Col :span="ItemCol" class="basic_item" v-for="talg in alibabaLogisticsInfoList">
                              <span class="basic_title">{{ talg.title + '：' }}</span>
                              <span class="basic_txt" :title="item.ymsPackageInfo[talg.paramsKey]">
                            {{ item.ymsPackageInfo[talg.paramsKey] }}</span>
                            </Col>
                          </Row>
                        </template>
                      </div>
                    </template>
                  </Panel>
                </Collapse>
              </div>
            </template>
          </div>
          <!--右边-->
          <div class="right_box">
            <!--平台订单地址信息-->
            <div class="platformOrderAddressInfo_box mb10">
              <div class="flex align-items-center mb6">
                <h2 class="title_styles mr10">{{ $t('key1006377') }}</h2>
                <span class="cursor distributorThemeColor" @click="switchBtn">
                {{ switchShowInfoTalg ? $t('key1000141') : $t('key1006351') }}
              </span>
              </div>
              <div class="ptb12 pl10 pr10 back-fff" v-if="switchShowInfoTalg">
                <p class="mb3">
                  <Icon type="ios-contact-outline" size="18"/>
                  <span class="ml5">{{ $t('key1006017') }} / ID</span>
                </p>
                <p class="mb3 flex align-items-center addressInfo_item">
                  <span class="ellipsisInfo" :title="(platformOrderDetails.buyerName || '-') + ' / ' + (platformOrderDetails.buyerAccountId || '-')">
                    {{ (platformOrderDetails.buyerName || '-') + ' / ' + (platformOrderDetails.buyerAccountId || '-') }}
                  </span>
                  <Icon type="ios-copy-outline" size="18" color="#01a6ee" class="ml4 cursor copy_icon" :title="$t('key1000003')"
                    @click="commonCopyContentFun((platformOrderDetails.buyerName || '') + ' / ' + (platformOrderDetails.buyerAccountId || ''))"/>
                </p>
                <Divider style="margin: 8px 0"/>
                <p class="mb3">
                  <Icon type="md-phone-portrait" size="18"/>
                  <span class="ml5">{{ $t('key1006018') }}</span>
                </p>
                <p class="mb3 flex align-items-center addressInfo_item">
                  <span class="addressInfo_label">Email：</span>
                  <span class="ellipsisInfo" :title="platformOrderDetails.buyerEmail">
                  {{ platformOrderDetails.buyerEmail || '-' }}
                </span>
                  <Icon type="ios-copy-outline" size="18" color="#01a6ee" class="ml4 cursor copy_icon" :title="$t('key1000003')"
                    @click="commonCopyContentFun(platformOrderDetails.buyerEmail)"/>
                </p>
                <p class="mb3 flex align-items-center addressInfo_item">
                  <span class="addressInfo_label">Phone：</span>
                  <span class="ellipsisInfo" :title="platformOrderDetails.buyerMobile">
                  {{ platformOrderDetails.buyerMobile || '-' }}
                </span>
                  <Icon type="ios-copy-outline" size="18" color="#01a6ee" class="ml4 cursor copy_icon" :title="$t('key1000003')"
                    @click="commonCopyContentFun(platformOrderDetails.buyerMobile)"/>
                </p>
                <p class="mb3 flex align-items-center addressInfo_item">
                  <span class="addressInfo_label">{{ $t('key1001175') }}</span>
                  <span class="ellipsisInfo" :title="platformOrderDetails.buyerPhone">
                  {{ platformOrderDetails.buyerPhone || '-' }}
                </span>
                  <Icon type="ios-copy-outline" size="18" color="#01a6ee" class="ml4 cursor copy_icon" :title="$t('key1000003')"
                    @click="commonCopyContentFun(platformOrderDetails.buyerPhone)"/>
                </p>
                <Divider style="margin: 8px 0"/>
                <p class="mb2">
                  <Icon type="ios-home" size="18"/>
                  <span class="ml5">{{ $t('key1005971') }}</span>
                </p>
                <p class="mb3 flex align-items-center addressInfo_item">
                  <span class="addressInfo_label">{{ $t('key1004392') }}</span>
                  <span class="ellipsisInfo" :title="platformOrderDetails.buyerAddress1">
                  {{ platformOrderDetails.buyerAddress1 || '-' }}
                </span>
                  <Icon type="ios-copy-outline" size="18" color="#01a6ee" class="ml4 cursor copy_icon" :title="$t('key1000003')"
                    @click="commonCopyContentFun(platformOrderDetails.buyerAddress1)"/>
                </p>
                <p class="mb3 flex align-items-center addressInfo_item">
                  <span class="addressInfo_label">{{ $t('key1004393') }}</span>
                  <span class="ellipsisInfo" :title="platformOrderDetails.buyerAddress2">
                  {{ platformOrderDetails.buyerAddress2 || '-' }}
                </span>
                  <Icon type="ios-copy-outline" size="18" color="#01a6ee" class="ml4 cursor copy_icon" :title="$t('key1000003')"
                    @click="commonCopyContentFun(platformOrderDetails.buyerAddress2)"/>
                </p>
                <p class="mb2 flex align-items-center addressInfo_item">
                  <span class="addressInfo_label">{{ $t('key1002598') }}</span>
                  <span class="ellipsisInfo" :title="platformOrderDetails.buyerCountryCode">
                  {{ platformOrderDetails.buyerCountryCode || '-' }}
                </span>
                  <Icon type="ios-copy-outline" size="18" color="#01a6ee" class="ml4 cursor copy_icon" :title="$t('key1000003')"
                    @click="commonCopyContentFun(platformOrderDetails.buyerCountryCode)"/>
                </p>
                <p class="mb2 flex align-items-center addressInfo_item">
                  <span class="addressInfo_label">{{ $t('key1001162') }}</span>
                  <span class="ellipsisInfo" :title="platformOrderDetails.buyerState">
                  {{ platformOrderDetails.buyerState || '-' }}
                </span>
                  <Icon type="ios-copy-outline" size="18" color="#01a6ee" class="ml4 cursor copy_icon" :title="$t('key1000003')"
                    @click="commonCopyContentFun(platformOrderDetails.buyerState)"/>
                </p>
                <p class="mb2 flex align-items-center addressInfo_item">
                  <span class="addressInfo_label">{{ $t('key1001164') }}</span>
                  <span class="ellipsisInfo" :title="platformOrderDetails.buyerCity">
                  {{ platformOrderDetails.buyerCity || '-' }}
                </span>
                  <Icon type="ios-copy-outline" size="18" color="#01a6ee" class="ml4 cursor copy_icon" :title="$t('key1000003')"
                    @click="commonCopyContentFun(platformOrderDetails.buyerCity)"/>
                </p>
                <p class="mb2 flex align-items-center addressInfo_item">
                  <span class="addressInfo_label">{{ $t('key1001170') }}</span>
                  <span class="ellipsisInfo" :title="platformOrderDetails.buyerPostalCode">
                  {{ platformOrderDetails.buyerPostalCode || '-' }}
                </span>
                  <Icon type="ios-copy-outline" size="18" color="#01a6ee" class="ml4 cursor copy_icon" :title="$t('key1000003')"
                    @click="commonCopyContentFun(platformOrderDetails.buyerPostalCode)"/>
                </p>
              </div>
            </div>
            <!--操作日志-->
            <div class="operationLog_box" v-if="orderHistoryList.length>0">
              <h2 class="title_styles mt17 mb6">{{ $t('key1000288') }}</h2>
              <div class="p10 back-fff operationLog_center" ref="scrollContainer">
                <Timeline>
                  <TimelineItem v-for="item in orderHistoryList" :key="item.ymsLogId">
                    <span slot="dot" class="dotStyles"></span>
                    <p class="font-weight-bold mb8 font-size-12" style="white-space: pre-line;">
                      {{ Array.isArray(item.logContent) ? item.logContent.join('\n') : item.logContent }}
                      <span class="cursor distributorThemeColor ml6" style="font-weight: initial;" v-if="item.contentType === 173"
                        @click="$refs['platformOrderLogDetails'].initPlatformOrderLogDetailsData(item)">{{ $t('key1000296') }}</span>
                    </p>
                    <p class="mb8 font-size-12">{{ $t('key1003158') + handleName(item) }}</p>
                    <p class="font-size-12">{{ $t('key1000770') + item.logTime }}</p>
                  </TimelineItem>
                </Timeline>
                <Divider v-if="!moreLogsTalg" style="margin: 0;padding: 10px 0 15px 0; font-size: 12px;">{{ $t('key1006378') }}</Divider>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Drawer>
    <!--取消订单弹窗-->
    <cancelPlatformOrderModal ref="cancelPlatformOrder" @updateData="updateData"></cancelPlatformOrderModal>
    <!--修改收货人信息弹窗-->
    <editReceiverModal ref="editReceiver" receiverType="platformOrder" @updateData="updateData"></editReceiverModal>
    <!--修改物流商信息弹窗-->
    <editLogisticsModal ref="editLogistics" @updateData="updateData"></editLogisticsModal>
    <!--添加商品弹窗-->
    <addCommonProductModal
      ref="addCommonProduct"
      :platformOrderDetails="platformOrderDetails"
      :apiUrl="apiUrl"
      :customStyle="true"
      :showOptionsBtn="false"
      systemType="distributor"
      :distributorShowFieldKeyList="['options', 'goodsInfo','myInventory', 'supplierAvailableNumber', 'ymsAvailableNumber', 'suggestPrice', 'weight', 'length', 'status']"
      @selectGoodsList="selectGoodsList"
      @updateData="updateData">
    </addCommonProductModal>
    <!--更换订单商品弹窗-->
    <replace-goods ref="replaceGoods" @success="updateData"></replace-goods>
    <!--temu_choice平台，Temu后台发货仓库弹窗-->
    <matchWarehouseModal ref="matchWarehouse" @success="updateData"></matchWarehouseModal>
    <!--商品发货仓弹窗-->
    <shippingWarehouseModal ref="shippingWarehouse" @updateData="updateData"></shippingWarehouseModal>
    <!--添加、调整订单弹窗-->
    <addYmsOrderModal ref="addYmsOrder" :ymsPlatformOrderTransactionsList="ymsPlatformOrderTransactionsList" @updateData="updateData"></addYmsOrderModal>
    <!--拆分订单弹窗-->
    <splitOrderModal ref="splitOrder" :ymsPlatformOrderTransactionsList="ymsPlatformOrderTransactionsList" @updateData="updateData"></splitOrderModal>
    <!--取消YMS订单弹窗-->
    <cancelPlatformYmsOrderModal ref="cancelYmsOrder" @updateData="updateData"></cancelPlatformYmsOrderModal>
    <!--平台订单日志详情弹窗-->
    <platformOrderLogDetailsModal ref="platformOrderLogDetails"></platformOrderLogDetailsModal>
    <!--待配置定制内容弹窗-->
    <configureCustomizedContentModal ref="configureCustomizedContent" @updateData="updateData"></configureCustomizedContentModal>
    <!--关联合规信息弹窗-->
    <relatedComplianceInfoModal ref="relatedComplianceInfo" @updateData="updateData"></relatedComplianceInfoModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import editReceiverModal from '@/views/distributor/components/orderManage/components/editReceiverModal';
import editLogisticsModal from '@/views/distributor/components/orderManage/components/editLogisticsModal';
import addCommonProductModal from "@/components/common/addCommonProductModal";
import api from '@/api/';
import cancelPlatformOrderModal from '@/views/distributor/components/orderManage/components/cancelPlatformOrderModal.vue';
import ReplaceGoods from '@/views/distributor/components/orderManage/components/replaceGoods';
import {
  getUserNameByUserId, handerDataSorting, amountAddition, getConverter,
  setConfigCharacters, isAlibabaDistributor, batchAllWarehouseData, getAllMatchingLogisticsData,
  getAllWarehouseData, commonLocalStorage, isValueEmpty, _handleMultilingualFields, getAllUsersInfo,
  commonCopyContent
} from "@/utils/common";
import {CANNOTCANCELPLATFORMORDERSLIST, YMSORDERSTATUSLIST} from "@/utils/enum";
import matchWarehouseModal from "@/views/distributor/components/orderManage/components/matchWarehouseModal.vue";
import shippingWarehouseModal from "@/views/distributor/components/orderManage/shippingWarehouseModal.vue";
import addYmsOrderModal from "@/views/distributor/components/orderManage/addYmsOrderModal.vue";
import splitOrderModal from "@/views/distributor/components/orderManage/splitOrderModal.vue";
import cancelPlatformYmsOrderModal from "@/views/distributor/components/orderManage/cancelPlatformYmsOrderModal.vue";
import platformOrderLogDetailsModal from "@/views/distributor/components/orderManage/platformOrderLogDetailsModal.vue";
import configureCustomizedContentModal from "@/components/common/configureCustomizedContentModal.vue";
import relatedComplianceInfoModal from "@/views/distributor/components/orderManage/relatedComplianceInfoModal.vue";

export default {
  name: 'platformOrderDetail',
  mixins: [Mixin],
  components: {
    relatedComplianceInfoModal,
    configureCustomizedContentModal,
    matchWarehouseModal,
    ReplaceGoods,
    cancelPlatformOrderModal,
    editReceiverModal,
    editLogisticsModal,
    addCommonProductModal,
    shippingWarehouseModal,
    addYmsOrderModal,
    splitOrderModal,
    cancelPlatformYmsOrderModal,
    platformOrderLogDetailsModal
  },
  data() {
    let v = this;
    return {
      apiUrl: api.post_ymsDistributorProductInfo_queryYmsProductGoods,
      ItemCol: 6,
      platformOrderDetailsModal: false,
      platformOrderStepList: [], // 平台订单的进度条
      platformOrderCurrent: 0,
      platformOrderDetails: {},
      ymsOrderInfoList: [], // YMS订单
      alibabaOrderInfoList: [], // 阿里国际订单
      collapseModal: [],
      cancelledTalg: false, // 订单状态为已取消时，不可以编辑只能查看
      reasonCancellationEbayModal: false,
      ymsPlatformOrderId: null,
      orderNumber: '',
      handerOptions: false,
      cancelStatusTalg: false,
      encryptionShow: false,
      encryptionTalg: true, // 默认是加密
      shippingAddressInfo: {}, // 收货地址
      switchShowInfoTalg: true, // 默认不展开平台订单地址信息
      logsPageParams: {
        pageNum: 1,
        pageSize: 15,
        businessId: null
      },
      hasAYMSOrderBeenPlaced: true,
      orderHistoryList: [],
      moreLogsTalg: true,
      replaceOrderItemTalg: false, // 更换订单商品的标识
      ymsPackageInfoTalg: false, // 标记是否生成YMS订单
      ebayPlatformTalg: false, // 标识eBay没有YMS订单时候是可以操作整单取消
      platformLogoPath: '',
      originalPlatformList: [],
      temuChoiceLogoPath: require('@/assets/images/platform/temu_choice.png'),
      matchingLogisticsData: [],
      converterData: [],
      ymsPlatformOrderTransactionsList: [],
      cannotCancelPlatformOrdersList: CANNOTCANCELPLATFORMORDERSLIST,
      userInfoList: {},
    };
  },
  mounted() {
    if (this.$refs['scrollContainer']) {
      this.$refs['scrollContainer'].addEventListener('scroll', this.handleScroll);
    }
  },
  computed: {
    // 判断是在预拆单的状态
    preSplitOrderStatusTalg() {
      return (![0, 1].includes(this.platformOrderDetails.status) && this.platformOrderDetails.status < 4) ||
        [11, 21].includes(this.platformOrderDetails.status);
    },
    logisticsInfoList() {
      let list = [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001581'), paramsKey: 'providerName', optionTalg: true, span: 24},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004440'), paramsKey: 'thirdPartyNo'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004458'), paramsKey: 'trackingNumber'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006329'), paramsKey: 'selfDeliveryTrackingNumber'}
      ];
      if (!(![0, 1].includes(this.platformOrderDetails.status) && this.platformOrderDetails.status < 4 ||
        [11, 21].includes(this.platformOrderDetails.status))) {
        list.push({title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001606'), paramsKey: 'orderShippingWarehouseName'});
      }
      if (this.platformOrderDetails.platformId === 'temu_choice') {
        list.push({title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006330'), paramsKey: 'platformWarehouseName', optionTalg: true});
      }
      return list;
    },
    // 判断是否展示取消平台订单 （平台订单中所有的YMS订单都支持取消时，即支持取消平台订单）
    /** isSupplierSupportDirectDelivery  供应商是否支持直接发货 0不支持 1支持
     * allowInvalid  1 允许标记取消   0不允许标记取消
     * YMS订单状态：1 已创建、2 备货中、3 待拣货、4 已拣货、5 已换单、6 已装箱、7 已发货、8 已取消
     * 当该YMS订单还没有下单之前，或者下单之后（YMS订单为供应商直发订单，YMS订单状态是已发货前、
     * YMS订单为中心仓发货订单，YMS订单状态是已装箱之前、YMS订单状态是已装箱且允许标记取消）
     */
    showCancelOrderBtn() {
      let showButton = false;
      const platformOrder = this.platformOrderDetails;
      let ymsPackageInfoExist = false;
      let newList = [];
      if (Object.keys(platformOrder).length > 0) {
        const ymsRelatedOrders = platformOrder.ymsPlatformOrderPackageRelateds || [];
        if (ymsRelatedOrders.length > 0) {
          // 过滤掉已取消的YMS订单
          newList = ymsRelatedOrders.filter((order) => {
            return order.ymsPackageInfo && order.ymsPackageInfo.status !== 8;
          });
          ymsPackageInfoExist = newList.length > 0;
        }
        const isPlatformOrderValid = platformOrder.isInvalid !== 1; // 平台订单没有作废

        if (isPlatformOrderValid) {
          // 还没有生成YMS订单，平台订单允许整单取消
          if (!ymsPackageInfoExist) {
            const supportedPlatforms = ['ebay', 'aliexpress', 'fruugo', 'ozon', 'shopee', 'walmart', 'wish'];
            if (supportedPlatforms.includes(platformOrder.platformId)) {
              showButton = true;
            }
          }
          // 已生成YMS订单
          else {
            newList.map((order) => {
              order.cancellationOfOrder = false;
              let {status, allowInvalid, isSupplierSupportDirectDelivery} = order.ymsPackageInfo;
              if (isSupplierSupportDirectDelivery === 1) {
                if (status < 7) {
                  order.cancellationOfOrder = true;
                }
              } else {
                order.cancellationOfOrder = status < 6 || (status === 6 && allowInvalid === 1);
              }
            });
            showButton = newList.every(order => {
              return order.cancellationOfOrder === true;
            });
          }
        }
      }
      this.ymsPackageInfoTalg = ymsPackageInfoExist;
      return showButton;
    },
    alibabaLogisticsInfoList() {
      return this.logisticsInfoList.filter((item) => {
        return item.paramsKey !== 'selfDeliveryTrackingNumber';
      });
    },
    // 判断是否阿里国际分销
    isAlibabaDistributorTalg() {
      return isAlibabaDistributor();
    },
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    // 订单合规标签校验配置项是否开启
    orderComplianceLabelVerificationTalg() {
      const saasConfigurationItems = commonLocalStorage.getItem('saasConfigurationItems') ?? this.$store.state.saasConfigurationItems;
      return Number(saasConfigurationItems?.orderComplianceLabelVerificationSaas) === 1;
    },
  },

  methods: {
    // 处理操作人名称
    handleName(item) {
      let name = getUserNameByUserId(item.updatedBy, this.userInfoList);
      return name;
    },
    // 总费用
    calcAmount({costOfGoods, costOfPackage, logisticsOfGoods, expressFee, customsClearanceFee}) {
      return amountAddition(costOfGoods, costOfPackage, logisticsOfGoods, expressFee, customsClearanceFee);
    },
    // 取消订单
    cancelOrderBtn(type) {
      this.$refs['cancelPlatformOrder'].initCancelOrderData(this.platformOrderDetails, this.ymsPlatformOrderId, this.ymsPackageInfoTalg, type);
    },
    // 人工匹配商品
    marryGoods(data) {
      this.$refs['addCommonProduct'].matchingGoodsType = 'manual';
      this.$refs['addCommonProduct'].ymsPlatformOrderTransactionId = data.ymsPlatformOrderTransactionId;
      this.$refs['addCommonProduct'].platformItemSku = data.platformItemSku;
      this.$refs['addCommonProduct'].initFun();
    },
    // 获取平台订单详情的信息
    async getPlatformOrderDetailsInfo(ymsPlatformOrderId, originalPlatformList) {
      let v = this;
      v.replaceOrderItemTalg = false;
      v.moreLogsTalg = true;
      v.orderHistoryList = [];
      v.logsPageParams.businessId = ymsPlatformOrderId;
      v.ymsOrderInfoList = [];
      v.alibabaOrderInfoList = [];
      v.platformOrderDetails = {};
      v.matchingLogisticsData = [];
      v.ymsPlatformOrderTransactionsList = [];
      v.platformLogoPath = '';
      v.ymsPlatformOrderId = ymsPlatformOrderId;
      await getConverter().then((list) => {
        v.converterData = list;
      });
      await getAllWarehouseData({servicePlatforms: ['core', 'supplier']}).then((warehouseData) => {
        commonLocalStorage.setItem('warehouseCacheData', warehouseData);
      });
      await getAllUsersInfo().then((data) => {
        v.userInfoList = data;
      });
      await v.getOrderHistoryData();
      v.axios.get(api.get_ymsPlatformOrder + ymsPlatformOrderId).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            // 平台logo图片
            if (data.platformId === 'temu_choice') {
              v.platformLogoPath = v.temuChoiceLogoPath;
            } else {
              if (originalPlatformList && originalPlatformList.length > 0) {
                v.originalPlatformList = originalPlatformList;
                originalPlatformList.map((item) => {
                  if (item.platformId === data.platformId) {
                    v.platformLogoPath = item.logoPath;
                  }
                });
              }
            }
            // 订单状态为已取消时，不可以编辑只能查看
            v.cancelledTalg = data.isInvalid === 1;
            // 平台订单的进度条
            v.platformOrderStepList = [
              {status: 0, icon: 'md-cash', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006331'), time: data.createdTime},
              {status: 1, icon: 'md-cart', title: data.matchCarrierTime ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006117') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006166'), time: data.matchCarrierTime},
              {status: 2, icon: 'md-clipboard', title: data.createdYmsPackageTime ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006209') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002918'), time: data.createdYmsPackageTime},
              {status: 3, icon: 'md-bus', title: data.despatchedTime ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006332') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006333'), time: data.despatchedTime}
            ];
            v.platformOrderStepList.map((item) => {
              if (item.time) {
                v.platformOrderCurrent = item.status;
                item.time = v.$uDate.dealTime(item.time, 'fulltime');
              }
            });
            // 处理速卖通平台信息解密、加密
            v.encryptionShow = data.platformId === 'aliexpress' && data.orderType !== 'ONE_STOP_SERVICE' ? true : false;
            // 下单时间
            data.createdYmsPackageTime = data.createdYmsPackageTime ? v.$uDate.dealTime(data.createdYmsPackageTime, 'fulltime') : '';
            // 付款时间
            data.payTime = data.payTime ? v.$uDate.dealTime(data.payTime, 'fulltime') : '';
            // 作废时间
            data.invalidTime = data.invalidTime ? v.$uDate.dealTime(data.invalidTime, 'fulltime') : '';
            // 平台订单
            data.ymsPlatformOrderTransactions = data.ymsPlatformOrderTransactions.map(i => {
              i.ymsProductGoodsId = i.businessId;
              return i;
            });
            if (data.isInvalid === 1) {
              data.invalidTypeText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006334');
            } else if (data.invalidType === 1) {
              data.invalidTypeText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006335');
            } else {
              data.invalidTypeText = '';
            }
            let businessIds = [];
            let ymsPlatformOrderTransactions = data.ymsPlatformOrderTransactions || [];
            if (ymsPlatformOrderTransactions.length > 0) {
              v.replaceOrderItemTalg = ymsPlatformOrderTransactions.some(i => i.matchType === 1);
              ymsPlatformOrderTransactions.map((item) => {
                item['unmatchedYmsSku'] = item.matchType === 0 ? true : false; // 匹配商品失败或者匹配商品为空，有不匹配YMS sku的操作
                if (item.businessId) {
                  businessIds.push(item.businessId);
                }
                item['name'] = item.platformItemSku + '+' + item.platformOrderTransactionId;
              });
            }
            if (businessIds.length > 0) {
              v.getProductInfoByIds(businessIds, ymsPlatformOrderTransactions).then((datas) => {
                if (datas && datas.length > 0) {
                  let ymsWarehouseIds = [];
                  datas.map((item) => {
                    item.shippingWarehouseName = '';
                    if (item.ymsWarehouseId) {
                      ymsWarehouseIds.push(item.ymsWarehouseId);
                    }
                    if (item._productInfo) {
                      let productGoodsSpecificationList = item._productInfo.productGoodsSpecificationList || [];
                      item.specifications = productGoodsSpecificationList.map(i => i.name + '：' + i.value).join('、');
                      item['primaryImage'] = item._productInfo.primaryImage || null;
                    }
                  });
                  if (ymsWarehouseIds.length > 0) {
                    batchAllWarehouseData(ymsWarehouseIds).then((ymsWarehouseData) => {
                      datas.map((item) => {
                        ymsWarehouseData.map((ele) => {
                          if (item.ymsWarehouseId === ele.ymsWarehouseId) {
                            item.shippingWarehouseName = ele.name;
                          }
                        });
                      });
                      data.ymsPlatformOrderTransactions = datas;
                      v.platformOrderDetails = data;
                    });
                  } else {
                    data.ymsPlatformOrderTransactions = datas;
                    v.platformOrderDetails = data;
                  }
                }
                v.platformOrderDetailsModal = true;
              });
            } else {
              v.platformOrderDetails = data;
              v.platformOrderDetailsModal = true;
            }
            v.$store.commit('platformOrderDetails', data)
            let ymsPlatformOrderPackageRelateds = data.ymsPlatformOrderPackageRelateds || [];
            let ymsPlatformOrderShippings = data.ymsPlatformOrderShippings || [];
            // YMS订单信息
            /**
             * 云卖平台订单状态
             * 0待处理 1.待匹配商品 11.待匹配商品发货仓  12.待配置定制内容 13.关联合规信息
             * 2.匹配物流失败 21.待下单 3.下单失败 4.已下单 5.已发货
             */
            if (![0, 1, 12, 13].includes(data.status) && data.status < 4 || [11, 21].includes(data.status)) {
              let newList = [];
              let newData = ymsPlatformOrderShippings.filter((item) => item.status !== 8); // 过滤掉已经作废的单
              if (newData.length > 0) {
                newData.map((item) => {
                  let {ymsPlatformOrderShippingDetails, ...obj} = item;
                  let ymsPlatformOrderShippingDetailsList = ymsPlatformOrderShippingDetails || [];
                  ymsPlatformOrderShippingDetailsList.map((ele) => {
                    ele.ymsProductGoodsId = ele.businessId;
                  });
                  ymsPlatformOrderPackageRelateds.map((ele) => {
                    if (item.ymsPlatformOrderShippingId === ele.ymsPlatformOrderShippingId) {
                      item.ymsPlatformOrderPackageRelatedId = ele.ymsPlatformOrderPackageRelatedId;
                    }
                  });
                  newList.push({
                    ...item,
                    ymsPackageInfo: {
                      ...obj,
                      performanceParty: 'YMS',
                      orderShippingWarehouseName: '',
                      ymsPackageGoods: ymsPlatformOrderShippingDetailsList
                    }
                  });
                });
                ymsPlatformOrderTransactions.map((talg) => {
                  newData.map((item) => {
                    let ymsPlatformOrderShippingDetailsList = item.ymsPlatformOrderShippingDetails || [];
                    ymsPlatformOrderShippingDetailsList.map((ele) => {
                      if (talg.platformOrderTransactionId === ele.platformOrderTransactionId) {
                        talg.ymsPlatformOrderShippingDetailId = ele.ymsPlatformOrderShippingDetailId;
                      }
                    });
                  });
                });
                v.ymsPlatformOrderTransactionsList = ymsPlatformOrderTransactions;
                setTimeout(() => {
                  v.handleYmsOrderData(data, newList, 'noOrderPlaced');
                }, 1000);
              }
            } else {
              if (ymsPlatformOrderPackageRelateds.length > 0) {
                ymsPlatformOrderPackageRelateds.forEach(item => {
                  if (item.ymsPackageInfo) {
                    const goods = item.ymsPackageInfo.ymsPackageGoods || [];
                    const details = item.ymsPackageInfo.ymsPackageGoodsDetails || [];
                    goods.forEach(good => {
                      const detail = details.find(d => d.ymsProductGoodsId === good.ymsProductGoodsId);
                      if (detail) {
                        good.platformOrderTransactionId = detail.platformOrderTransactionId;
                      }
                    });
                    item.ymsWarehouseId = item.ymsPackageInfo.ymsWarehouseId;
                  }
                });
                ymsPlatformOrderTransactions.map((talg) => {
                  ymsPlatformOrderPackageRelateds.map((ele) => {
                    if (ele.ymsPackageInfo && ele.ymsPackageInfo.status !== 8) {
                      const details = ele.ymsPackageInfo.ymsPackageGoodsDetails || [];
                      details.map((k) => {
                        if (talg.platformOrderTransactionId === k.platformOrderTransactionId) {
                          talg.ymsPlatformOrderShippingDetailId = k.ymsPlatformOrderShippingDetailId;
                        }
                      });
                    }
                  });
                });
                v.ymsPlatformOrderTransactionsList = ymsPlatformOrderTransactions;
                setTimeout(() => {
                  v.handleYmsOrderData(data, ymsPlatformOrderPackageRelateds, 'orderPlaced');
                }, 1000);
              }
            }
          }
        }
      });
    },
    // 处理订单数据
    handleYmsOrderData(data, ymsOrderInfoList, typeStatus) {
      let v = this;
      let partList = [];
      let newYmsOrderList = [];
      let ymsOrderList = [];
      v.collapseModal = [];
      v.shippingAddressInfo = {};
      if (ymsOrderInfoList.length > 0) {
        ymsOrderInfoList.map((item) => {
          let ymsPackageInfo = item.ymsPackageInfo;
          if (ymsPackageInfo) {
            let ymsPackageGoodsList = ymsPackageInfo.ymsPackageGoods || [];
            newYmsOrderList.push(...ymsPackageGoodsList);
          }
        });
        if (newYmsOrderList.length > 0) {
          let ymsProductGoodsIds = [];
          newYmsOrderList.map((item) => {
            ymsProductGoodsIds.push(item.ymsProductGoodsId);
          });
          if (ymsProductGoodsIds.length > 0) {
            (async () => {
              const warehouseMap = {};
              const ymsWarehouseAddressMap = {};
              const ymsWarehouseIds = ymsOrderInfoList.map(item => item.ymsPackageInfo && item.ymsPackageInfo.ymsWarehouseId).filter(Boolean);
              if (ymsWarehouseIds.length > 0) {
                let warehouseData = await batchAllWarehouseData(ymsWarehouseIds);
                warehouseData.forEach(warehouse => {
                  warehouseMap[warehouse.ymsWarehouseId] = warehouse.name;
                  ymsWarehouseAddressMap[warehouse.ymsWarehouseId] = warehouse.ymsWarehouseAddress || [];
                });
                let query = {
                  warehouseIds: ymsWarehouseIds
                }
                if (data.orderTag === 'TIKTOK_CBT') {
                  query.performanceType = 2;
                }
                v.matchingLogisticsData = await getAllMatchingLogisticsData(query);
              }
              // 未下单
              if (typeStatus === 'noOrderPlaced') {
                let query = {
                  distributorMerchantId: v.userInfo.merchantId,
                  orderGoodsDetailBos: []
                };
                let list = [];
                ymsOrderInfoList.map((item) => {
                  let ymsPackageInfo = item.ymsPackageInfo;
                  if (ymsPackageInfo) {
                    let ymsWarehouseId = ymsPackageInfo.ymsWarehouseId;
                    let goodList = ymsPackageInfo.ymsPackageGoods || [];
                    let arr = goodList.map((good) => {
                      return {
                        ...good,
                        ymsWarehouseId: ymsWarehouseId
                      };
                    });
                    list.push(...arr);
                  }
                });
                list.map((item) => {
                  query.orderGoodsDetailBos.push({
                    ymsProductGoodsId: item.ymsProductGoodsId,
                    ymsWarehouseId: item.ymsWarehouseId
                  });
                });
                ymsOrderList = await v.getProductInfoByIds(query, newYmsOrderList, false, false, false,
                  api.post_ymsProductInf_api_queryDistributorOrderGoodsDetail);
              }
              // 已下单
              else {
                ymsOrderList = await v.getProductInfoByIds(ymsProductGoodsIds, newYmsOrderList);
              }
              if (ymsOrderList.length > 0) {
                // 累加费用方法
                function sumNumByType(arr) {
                  const result = {};
                  for (let i = 0; i < arr.length; i++) {
                    const obj = arr[i];
                    const type = obj.type;
                    const amount = obj.amount || 0;

                    if (type in result) {
                      result[type] += amount;
                    } else {
                      result[type] = amount;
                    }
                  }
                  return result;
                }

                ymsOrderInfoList.forEach((item, index) => {
                  item.packageCode = item.packageCode ? item.packageCode : '';
                  item.goodsList = [];
                  item.costOfGoods = 0;
                  item.costOfPackage = 0;
                  item.logisticsOfGoods = 0;
                  item.expressFee = 0;
                  item.customsClearanceFee = 0;
                  let ymsPackageInfo = item.ymsPackageInfo;
                  let ymsPackageCosts = item.ymsPackageCosts || [];
                  item.costsTypeList = [];
                  if (ymsPackageCosts.length > 0) {
                    // 费用类型 1 货品费用  2 包裹处理费 3退费 4物流费 6快递费 7清关费用 8订单取消处理费 9供应商自有物流费用
                    let obj = sumNumByType(ymsPackageCosts);
                    item.costsTypeList = ymsPackageCosts.map((ele) => {
                      return ele.type;
                    });
                    item.costOfGoods = obj['1'];  // 商品费
                    item.costOfPackage = obj['2']; // 处理费
                    item.logisticsOfGoods = !isValueEmpty(obj['4']) ? obj['4'] : obj['9']; // 物流费
                    item.expressFee = obj['6'];
                    item.customsClearanceFee = obj['7'];
                  }
                  // 费用明细还没有生成时
                  else {
                    item.costOfGoods = ymsPackageInfo?.totalProductGoodsCost || 0;
                    item.costOfPackage = ymsPackageInfo?.prepayPackageHandlerCost || 0;
                    item.logisticsOfGoods = ymsPackageInfo?.payStatus === 1 ? ymsPackageInfo.estimateFreight : 0;
                  }
                  let stepsList = [];
                  if (ymsPackageInfo) {
                    let {ymsLogisServiceId, carrierId, shippingMethodId, ymsWarehouseId} = ymsPackageInfo;
                    v.matchingLogisticsData.map((ele) => {
                      if (ele.ymsWarehouseId === ymsWarehouseId) {
                        ele.logisticsData.map((talg) => {
                          talg.list.map((k) => {
                            // 云卖物流
                            if (ymsLogisServiceId) {
                              if (k.ymsLogisServiceId === ymsLogisServiceId) {
                                item.ymsPackageInfo['providerName'] = k.name;
                              }
                            }
                            // 自有物流、供应商物流
                            else {
                              if (carrierId && shippingMethodId) {
                                if ((k.carrierId === carrierId && k.shippingMethodId === shippingMethodId) ||
                                  (k.coreCarrierId === carrierId && k.coreShippingMethodId === shippingMethodId)) {
                                  item.ymsPackageInfo['providerName'] = k.name;
                                }
                              }
                            }
                          });
                        });
                      }
                    });
                    // 商品发货仓
                    item.ymsPackageInfo['orderShippingWarehouseName'] = warehouseMap[ymsWarehouseId] || '';
                    item.ymsPackageInfo['orderShippingWarehouseAddress'] = ymsWarehouseAddressMap[ymsWarehouseId] || [];
                    // YMS订单的进度条
                    if (ymsPackageInfo.performanceParty === 'YMS') {
                      let needPurchaseTalg = ymsPackageInfo.needPurchase === 0; // 0 YMS订单不需要采购
                      if (needPurchaseTalg) {
                        stepsList = [
                          {status: 0, icon: 'md-cash', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001799'), time: ymsPackageInfo.createdTime},
                          {status: 1, icon: 'ios-basket', title: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000672')}`, time: null},
                          {status: 2, icon: 'md-car', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006129'), time: null}
                        ];
                      } else {
                        stepsList = [
                          {status: 0, icon: 'md-cash', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001799'), time: ymsPackageInfo.createdTime},
                          {status: 1, icon: 'md-cart', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006130'), time: null},
                          {status: 2, icon: 'ios-basket', title: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000672')}`, time: null},
                          {status: 3, icon: 'md-car', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006129'), time: null}
                        ];
                      }
                      item.ymsOrderStatus = ymsPackageInfo.status;
                      // 处理轨迹节点数据
                      let ymsOrderStatus = ymsPackageInfo.ymsOrderStatus;
                      let arr = YMSORDERSTATUSLIST.filter((k) => {
                        if (needPurchaseTalg) {
                          return k.value <= ymsOrderStatus && k.value !== 'null' && k.value >= 6;
                        } else {
                          return k.value <= ymsOrderStatus && k.value !== 'null';
                        }
                      });
                      if (arr.length > 0) {
                        let keyList = arr.map((j) => {
                          return j.key;
                        });
                        keyList.map((val) => {
                          for (let key in ymsPackageInfo) {
                            if (val === key) {
                              if (ymsPackageInfo[key]) {
                                let text = '';
                                if (needPurchaseTalg) {
                                  switch (key) {
                                    case 'allottedTime':
                                      text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001808');
                                      if (key === 'allottedTime') {
                                        if (ymsPackageInfo.packagePattern === 1) {
                                          stepsList[1].time = ymsPackageInfo[key];
                                        } else if (ymsPackageInfo.packagePattern === 2) {
                                          stepsList[1].time = ymsPackageInfo[key];
                                        }
                                      }
                                      stepsList[1].text = text;
                                      break;
                                    case 'pickedTime':
                                      text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001809');
                                      stepsList[1].time = ymsPackageInfo[key];
                                      stepsList[1].text = text;
                                      break;
                                    case 'changedLabelTime':
                                      text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001810');
                                      stepsList[1].time = ymsPackageInfo[key];
                                      stepsList[1].text = text;
                                      break;
                                    case 'boxedTime':
                                      text = '';
                                      stepsList[1].time = ymsPackageInfo[key];
                                      stepsList[1].text = text;
                                      break;
                                    case 'shipedTime':
                                      stepsList[1].title = `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006117')}`;
                                      stepsList[2].time = ymsPackageInfo[key];
                                      stepsList[2].title = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006131');
                                      break;
                                  }
                                } else {
                                  switch (key) {
                                    case 'printTime':
                                      text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001802');
                                      stepsList[1].time = ymsPackageInfo[key];
                                      stepsList[1].text = text;
                                      break;
                                    case 'pickingFinishTime':
                                      text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001803');
                                      stepsList[1].time = ymsPackageInfo[key];
                                      stepsList[1].text = text;
                                      break;
                                    case 'packingTime':
                                      text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001804');
                                      stepsList[1].time = ymsPackageInfo[key];
                                      stepsList[1].text = text;
                                      break;
                                    case'supperBoxedTime':
                                      text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001805');
                                      stepsList[1].time = ymsPackageInfo[key];
                                      stepsList[1].text = text;
                                      break;
                                    case 'despatchTime':
                                      text = '';
                                      stepsList[1].time = ymsPackageInfo[key];
                                      stepsList[1].text = text;
                                      break;

                                    case 'allottedTime':
                                      stepsList[1].title = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005932');
                                      text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001808');
                                      if (key === 'allottedTime') {
                                        if (ymsPackageInfo.packagePattern === 1) {
                                          stepsList[2].time = ymsPackageInfo[key];
                                        } else if (ymsPackageInfo.packagePattern === 2) {
                                          stepsList[2].time = ymsPackageInfo[key];
                                        }
                                      }
                                      stepsList[2].text = text;
                                      break;
                                    case 'pickedTime':
                                      stepsList[1].title = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005932');
                                      text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001809');
                                      stepsList[2].time = ymsPackageInfo[key];
                                      stepsList[2].text = text;
                                      break;
                                    case 'changedLabelTime':
                                      stepsList[1].title = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005932');
                                      text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001810');
                                      stepsList[2].time = ymsPackageInfo[key];
                                      stepsList[2].text = text;
                                      break;
                                    case 'boxedTime':
                                      stepsList[1].title = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005932');
                                      text = '';
                                      stepsList[2].time = ymsPackageInfo[key];
                                      stepsList[2].text = text;
                                      break;
                                    case 'shipedTime':
                                      stepsList[2].title = `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006117')}`;
                                      stepsList[3].time = ymsPackageInfo[key];
                                      stepsList[3].title = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006131');
                                      break;
                                  }
                                }
                              }
                            }
                          }
                        });
                      }
                    }
                    // 阿里国际的进度条
                    else if (ymsPackageInfo.performanceParty === 'ALIGJ') {
                      stepsList = [
                        {status: 0, icon: 'md-cash', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001799'), time: ymsPackageInfo.createdTime},
                        {status: 1, icon: 'md-car', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006336'), time: ymsPackageInfo.shipedTime}
                      ];
                    }
                    if (stepsList.length > 0) {
                      let currentStatus = 0;
                      stepsList.map((ele) => {
                        if (ele.time) {
                          currentStatus = ele.status;
                          ele.time = v.$uDate.dealTime(ele.time, 'fulltime');
                        }
                      });
                      item.currentStatus = currentStatus;
                      item.ymsOrderStepsList = stepsList;
                    }
                    if (ymsPackageInfo.createdTime) {
                      ymsPackageInfo.createdTime = v.$uDate.dealTime(ymsPackageInfo.createdTime, 'fulltime');
                    }
                    // 商品列表的数据
                    item.selectGoodsData = [];
                    let list = ymsPackageInfo.ymsPackageGoods || [];
                    if (list.length > 0) {
                      list.map((talg) => {
                        let abnormalStatusText = '';
                        ymsOrderList.map((ele) => {
                          if (talg.ymsProductGoodsId === ele.ymsProductGoodsId) {
                            if (ele._productInfo) {
                              let productGoodsSpecificationList = ele._productInfo.productGoodsSpecificationList || [];
                              talg.variations = productGoodsSpecificationList.map(i => i.name + '：' + i.value).join('、');
                              let skuImgPath = ele._productInfo.primaryImage;
                              let spuImgPath = ele._productInfo._spuInfo.primaryImage;
                              let imgPath = skuImgPath ? skuImgPath : spuImgPath;
                              talg['pictureUrl'] = imgPath || null;
                              talg.name = ele._productInfo._spuInfo.name;
                              let number1 = v.converterData[ele._productInfo.currency];
                              let number2 = v.converterData[v.currencyState];
                              let suggestPrice = 0;
                              let queryOrderGoodsDetailBos = ele._productInfo.queryOrderGoodsDetailBos || [];
                              queryOrderGoodsDetailBos.map((k) => {
                                if (k.ymsWarehouseId === ymsWarehouseId) {
                                  suggestPrice = k.suggestPrice;
                                }
                              });
                              let goodSuggestPrice = (suggestPrice * number1) / number2;
                              talg['goodSuggestPrice'] = Number(goodSuggestPrice.toFixed(2));
                              talg['goodWeight'] = ele._productInfo.weight;
                              talg['goodCurrency'] = ele._productInfo.currency;
                              talg['_productInfo'] = ele._productInfo;
                              talg['ymsSpu'] = ele._productInfo._spuInfo.ymsSpu;
                              talg['specifications'] = productGoodsSpecificationList.map(i => i.value).join(' • ');
                              talg['ymsProductId'] = ele._productInfo.ymsProductId;
                            }
                          }
                        });
                        talg.name = _handleMultilingualFields(talg.name);
                        let estimateArrivalOfGoodsTime = ymsPackageInfo.estimateArrivalOfGoodsTime ?
                          v.$uDate.dealTime(ymsPackageInfo.estimateArrivalOfGoodsTime) : null;
                        let estimateArrivalOfGoodsTimeTxt = estimateArrivalOfGoodsTime ? (aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006337') + estimateArrivalOfGoodsTime) : '';
                        if ([2, 3].includes(ymsPackageInfo.abnormalStatus) && talg.outOfStockQuantity) {
                          abnormalStatusText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004360') + talg.outOfStockQuantity;
                        }
                        if (talg.goodsStatus === 1) {
                          talg['abnormalStatusText'] = abnormalStatusText ? (abnormalStatusText + estimateArrivalOfGoodsTimeTxt) : '';
                        } else {
                          talg['abnormalStatusText'] = abnormalStatusText ? (abnormalStatusText + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006338')) : '';
                        }
                        let platformOrderTransactionId = talg.platformOrderTransactionId || (v.ymsPlatformOrderTransactionsList.length > 0 ?
                          v.ymsPlatformOrderTransactionsList[0].platformOrderTransactionId : null);
                        talg.platformOrderTransactionId = platformOrderTransactionId;
                      });
                    }
                    item.goodsList = list;
                    // 判断是否存在部分取消的订单
                    if (ymsPackageInfo.status === 8) {
                      partList.push(item);
                    }
                  }
                });
                let newOrderList = ymsOrderInfoList.sort(handerDataSorting('ymsOrderStatus', 'asc'));
                // YMS订单
                v.ymsOrderInfoList = newOrderList.filter((item) => {
                  return item.ymsPackageInfo && item.ymsPackageInfo.performanceParty === 'YMS';
                });
                // 阿里国际订单
                v.alibabaOrderInfoList = newOrderList.filter((item) => {
                  return item.ymsPackageInfo && item.ymsPackageInfo.performanceParty === 'ALIGJ';
                });
                v.hasAYMSOrderBeenPlaced = false;
                v.$forceUpdate();
              }
            })();
          }
        }
      }
      data['partTalg'] = partList.length > 0 ? true : false;
    },
    // 修改信息，同步更新平台订单详情的数据
    updateData() {
      this.getPlatformOrderDetailsInfo(this.ymsPlatformOrderId, this.originalPlatformList);
      this.$emit('updatePlatformList', true);
    },
    // 监听已选中的商品数据
    selectGoodsList(data) {
      let v = this;
      let packageCode = data.packageCode;
      let selectList = data.selectList;
      v.ymsOrderInfoList.map((item, index) => {
        if (item.packageCode === packageCode) {
          v.$set(v.ymsOrderInfoList[index], 'goodsList', [...item.goodsList, ...selectList]);
          v.ymsOrderInfoList[index].goodsList = v.uniqueFunc(v.ymsOrderInfoList[index].goodsList, 'ymsProductGoodsId');
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005226'));
        }
      });
      v.$forceUpdate();
    },
    // 解密买家信息
    decryptBuyerInfo(obj, type) {
      let v = this;
      v.axios.get(api.get_ymsDistributorPackageInfo_tradeSellerOrderDecrypt + v.ymsPlatformOrderId).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            v.ymsOrderInfoList.map((item) => {
              for (let key in data) {
                item.ymsPackageInfo[key] = data[key];
              }
            });
            v.encryptionTalg = false;
            v.$forceUpdate();
            if (obj) {
              v.$refs['editReceiver'].initEditReceiverData(obj, type);
            }
          }
        }
      });
    },
    // 不匹配YMS sku
    unmatchedYmsSkuBtn(item, index) {
      let v = this;
      const count = v.platformOrderDetails.ymsPlatformOrderTransactions.filter(item => item.isMatchSku === 1).length;
      // 不匹配sku到最后一个商品时，平台订单会被标记为非YMS订单
      if (count === 1) {
        let content = `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006326')}
                     ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006327')}
                     ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006328')}<span class="distributorThemeColor ml2 mr2">${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006176')}${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001887')}</span>”`;
        v.$Modal.confirm({
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006339'),
          content: content,
          width: 550,
          dangerouslyUseHTMLString: true,
          okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005587'),
          cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
          onOk: () => {
            v.markUnmatchedYmsSku(item, index).then(() => {
              v.platformOrderDetailsModal = false;
              v.$emit('updatePlatformList', true);
            });
          },
          onCancel: () => {

          }
        });
      } else {
        v.markUnmatchedYmsSku(item, index).then(() => {
          setTimeout(() => {
            v.getPlatformOrderDetailsInfo(v.ymsPlatformOrderId, v.originalPlatformList);
          }, 400);
        });
      }
    },
    // 标记不匹配sku
    markUnmatchedYmsSku(item, index) {
      return new Promise((resolve) => {
        let query = {
          ymsPlatformOrderId: item.ymsPlatformOrderId,
          ymsPlatformOrderTransactionId: item.ymsPlatformOrderTransactionId
        };
        this.axios.post(api.post_ymsPlatformOrder_notMatchProductGoods, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
          if (response.data.code === 0) {
            this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
            let unmatchedYmsSku = !item.unmatchedYmsSku;
            this.$set(this.platformOrderDetails.ymsPlatformOrderTransactions[index], 'unmatchedYmsSku', unmatchedYmsSku);
            this.$forceUpdate();
            resolve(true);
          }
        });
      });
    },
    // 展开、收起--平台订单地址信息
    switchBtn() {
      let v = this;
      v.switchShowInfoTalg = !v.switchShowInfoTalg;
    },
    // 一键复制文本内容
    commonCopyContentFun(value) {
      commonCopyContent(value || '', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001286'));
    },
    // 编辑收货地址信息
    editShippingAddressInfoBtn(item, type) {
      let v = this;
      if (v.encryptionShow) {
        v.decryptBuyerInfo(item, type);
      } else {
        v.$refs['editReceiver'].initEditReceiverData(item, type);
      }
    },

    // 获取列表数据
    getOrderHistoryData() {
      let v = this;
      return new Promise((resolve) => {
        v.axios.post(api.post_ymsLog_query, v.logsPageParams).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            let list = data.list || [];
            if (list.length > 0) {
              list.map((item) => {
                item.logTime = v.$uDate.dealTime(item.updatedTime, 'fulltime') || '-';
              });
              let newList = v.handleMultilingualLogs(list);
              v.orderHistoryList = [...v.orderHistoryList, ...newList];
              v.total = data.total;
              if (v.orderHistoryList.length < v.total) {
                v.moreLogsTalg = true;
              } else {
                v.moreLogsTalg = false;
              }
            }
            resolve(true);
          }
        });
      });
    },
    // 滚动加载更多的操作日志
    handleScroll() {
      let v = this;
      const scrollContainer = this.$refs.scrollContainer;
      const distanceToBottom = scrollContainer.scrollHeight - (scrollContainer.scrollTop + scrollContainer.clientHeight);
      if (distanceToBottom <= 50 && v.moreLogsTalg) {
        v.logsPageParams.pageNum += 1;
        v.moreLogsTalg = false;
        v.getOrderHistoryData();
      }
    },
    // 操作选择物流、仓库
    operationChange(item, talg) {
      let type = talg.paramsKey;
      switch (type) {
        // 物流
        case 'providerName':
          let logisticsModeData = [];
          let ymsWarehouseId = item.ymsWarehouseId;
          this.matchingLogisticsData.map((ele) => {
            if (ele.ymsWarehouseId === ymsWarehouseId) {
              logisticsModeData = ele.logisticsData;
            }
          });
          item['logisticsModeData'] = logisticsModeData;
          this.$refs['editLogistics'].initEditLogisticsData(item, 'detailsType', this.platformOrderDetails);
          break;
        // 发货仓库
        case 'platformWarehouseName':
          this.$refs['matchWarehouse'].initMatchWarehouseData(item, 'platformOrderDetail');
          break;
      }
    },
    // 判断操作按钮（拆分订单、调整订单、取消订单）展示
    /** isSupplierSupportDirectDelivery  供应商是否支持直接发货 0不支持 1支持
     * allowInvalid  1 允许标记取消   0不允许标记取消
     * YMS订单状态：1 已创建、2 备货中、3 待拣货、4 已拣货、5 已换单、6 已装箱、7 已发货、8 已取消
     * 当该YMS订单还没有下单之前，或者下单之后（YMS订单为供应商直发订单，YMS订单状态是已发货前、
     * YMS订单为中心仓发货订单，YMS订单状态是已装箱之前、YMS订单状态是已装箱且允许标记取消）
     */
    isShowOptionsFun(item, type) {
      let isShow = false;
      let {status} = this.platformOrderDetails;
      const handleData = (obj) => {
        let talg = false;
        // YMS订单信息   云卖平台订单状态 0待处理 1.待匹配商品 11.待匹配商品发货仓 2.匹配物流失败 21.待下单 3.下单失败 4.已下单 5.已发货
        if (![0, 1].includes(status) && status < 4 || [11, 21].includes(status)) {
          talg = true;
        } else {
          if (obj.ymsPackageInfo) {
            let {isSupplierSupportDirectDelivery, status, allowInvalid} = obj.ymsPackageInfo;
            if (isSupplierSupportDirectDelivery === 1) {
              talg = status < 7;
            } else {
              talg = status < 6 || (status === 6 && allowInvalid === 1);
            }
          }
        }
        return talg;
      };
      switch (type) {
        // 拆分订单 （当该YMS订单中商品数量总和≥2）
        case 'splitOrder':
          let goodsList = item.goodsList || [];
          let totalQuantity = goodsList.reduce((pre, cur) => {
            return pre + cur.quantity;
          }, 0);
          isShow = handleData(item) && totalQuantity >= 2;
          break;
        // 取消订单
        case 'cancelOrder':
          isShow = handleData(item);
          break;
        // 调整订单
        case 'adjustOrder':
          isShow = handleData(item);
          break;
        // 修改物流 (平台订单下单之前都可以修改)
        case 'logistics':
          isShow = ![0, 1].includes(status) && status < 4 || [11, 21].includes(status);
          break;
      }
      return isShow;
    },
    // 平台商品匹配
    platformProductChange(val) {
      let obj = {};
      this.ymsPlatformOrderTransactionsList.map((item) => {
        if (item.platformOrderTransactionId === val) {
          obj.ymsPlatformOrderShippingDetailId = item.ymsPlatformOrderShippingDetailId;
          obj.ymsPlatformOrderTransactionId = item.ymsPlatformOrderTransactionId;
        }
      });
      if (Object.keys(obj).length > 0) {
        this.axios.post(api.post_ymsPlatformOrder_updatePlatformOrderShippingDetail, obj,
          {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
          if (response.data.code === 0) {
            this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006340'));
            this.updateData();
          }
        });
      }
    },
    // 监听抽屉
    visibleChange(value) {
      if (!value) {
        commonLocalStorage.removeItem('warehouseCacheData');
      }
    }
  },
  watch: {
    ymsOrderInfoList: {
      handler(data) {
        let v = this;
        if (data && data.length > 0) {
          v.handerOptions = !data.every(i => i.ymsPackageInfo && i.ymsPackageInfo.status >= 6);
          v.cancelStatusTalg = data.every(i => i.ymsPackageInfo && i.ymsPackageInfo.status === 8);
          // 只展开有效的YMS订单，折叠已取消的运满满订单
          data.map((item, index) => {
            if (item.ymsPackageInfo && item.ymsPackageInfo.status !== 8) {
              v.collapseModal.push(index.toString());
            }
          });
        }
      },
      immediate: true,
      deep: true
    },
    platformOrderDetails: {
      handler(obj) {
        if (obj) {
          this.ebayPlatformTalg = false;
          if ((!obj.ymsPlatformOrderPackageRelateds || obj.ymsPlatformOrderPackageRelateds.length <= 0) && obj.isInvalid !== 1) {
            if (obj.platformId === 'ebay') {
              this.ebayPlatformTalg = true;
            }
          }
          if (obj.platformId === 'ebay' && obj.isInvalid === 1) {
            this.cancelStatusTalg = true;
          }
        }
      },
      immediate: true,
      deep: true
    }
  }
};
</script>

<style lang="less" scoped>
.platformOrderDetails_box {
  /deep/ .ivu-drawer-header {
    padding: 0 16px;
  }

  /deep/ .ivu-drawer-body {
    padding: 0;
    background-color: #EFF0F5;
  }

  /deep/ .ivu-steps-content {
    padding: 0 !important;
  }

  /deep/ .ivu-collapse {
    border: none;
    background-color: transparent;

    .ivu-collapse-item {
      border-top: none;
    }

    .ivu-collapse-header {
      background-color: #fff;
      min-height: 38px;
      height: auto;
      line-height: inherit;

      .collapse-header {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        padding: 10px 0;
        cursor: default;
        z-index: 10;
      }
    }

    .ivu-collapse-content > .ivu-collapse-content-box {
      padding-bottom: 10px;
    }
  }

  .platformOrderContent_box {
    padding: 12px 14px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    .title_styles {
      font-size: 15px;
      font-weight: bold;
      color: #000;
    }

    .goodsInfo_box {
      display: flex;
      align-items: flex-start;
      font-size: 13px;
      margin-bottom: 12px;

      .img_styles {
        width: auto;
        min-width: 80px;
        height: 100px;
        display: inline-block;
        vertical-align: middle;
        cursor: pointer;
        max-width: 300px;
      }

      .img_yms_styles {
        width: auto;
        min-width: 50px;
        height: 70px;
        display: inline-block;
        vertical-align: middle;
        cursor: pointer;
        max-width: 300px;
      }
    }

    .ellipsisStyle {
      display: inline-block;
      max-width: 230px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .ellipsisInfo {
      display: inline-block;
      max-width: 150px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .platformOrderAddressInfo_box {
      .addressInfo_item {
        flex-wrap: nowrap;
        width: 100%;
      }

      .addressInfo_label {
        flex-shrink: 0;
        white-space: nowrap;
      }

      .ellipsisInfo {
        flex: 1;
        min-width: 0;
        max-width: none;
      }

      .copy_icon {
        flex-shrink: 0;
      }
    }

    .left_box {
      width: 1200px;
    }

    .right_box {
      width: 250px;
    }
  }

  .ymsOrderInfo_box {
    .h-price {
      color: #FD5425;
      font-weight: bold;
    }

    /deep/ .ivu-collapse-header {
      color: #333;
      font-size: 14px;
      font-weight: 700;
      display: flex;
      align-items: center;
    }

    .options_boxs {
      display: flex;
      align-items: center;
      margin-bottom: 15px;
    }


    .steps_box /deep/ {
      .ivu-steps .ivu-steps-title {
        font-size: 13px;
      }
    }
  }

  .operationLog_center {
    font-size: 12px;
    max-height: 700px;
    overflow-y: auto;

    .dotStyles {
      display: inline-block;
      width: 10px;
      height: 10px;
      background-color: #FD5425;
      border-radius: 50%;
    }
  }
}
</style>
